export enum UTMParams {
  utm_campaign = 'utm_campaign',
  utm_medium = 'utm_medium',
  utm_content = 'utm_content',
  utm_term = 'utm_term',
  utm_source = 'utm_source',
  utm_email_campaign = 'utm_email_campaign',
  utm_ltp_email_campaign = 'utm_ltp_email_campaign',
}

export enum SecondaryUTMParams {
  source = 'source',
  onboardId = 'onboardId',
  test_event_code = 'test_event_code', // tiktok debug
}
export enum OtherUrlParams {
  fbclid = 'fbclid',
  fbc = 'fbc',
  fbp = 'fbp',
  gclid = 'gclid',
  wbraid = 'wbraid',
  gbraid = 'gbraid',
  sid = 'sid',
  fva = 'fva',
  mfva = 'mfva', // milliseconds
  contact_id = 'contact_id',
  email = 'email',
  token = 'token',
  plan_id = 'plan_id',
  content_price_id = 'content_price_id',
  page_set_id = 'page_set_id',
  drop_session = 'drop_session',
  show_storage = 'show_storage',
  disable_analytics = 'disable_analytics',
  app_country_tier = 'app_country_tier',
  twclid = 'twclid',
  ttclid = 'ttclid',
}

export type TURLParams = UTMParams | SecondaryUTMParams | OtherUrlParams

const knownParams: TURLParams[] = [
  ...Object.values(UTMParams),
  ...Object.values(SecondaryUTMParams),
  ...Object.values(OtherUrlParams),
]

export type TURLParamsData = Partial<Record<TURLParams, string | undefined>>

export function getParamsFromQuery(): TURLParamsData {
  const paramsFromURL = new URLSearchParams(window.location.search)
  const params: TURLParamsData = {}

  knownParams.forEach((paramName) => {
    const result = paramsFromURL.get(paramName)
    if (result) {
      params[paramName] = result
    }
  })

  return params
}
